import React from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
import Select from 'react-select'

import HomeLarge from '../../components/HomeLarge';
import HomeMini from '../../components/HomeMini';

import CustomHeader from '../../components/Header'
import GroupVRNSelect from '../../containers/comps/GroupVRNSelectContainer'
import axiosConfig from '../../config/axiosConfig'


const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? 'black' : 'black',
        backgroundColor: state.isSelected ? 'yellow' : 'white'
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: '50px',
        borderColor: 'Yellow'

    })
}

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

const current = new Date();

function Iframe(props) {

    return (
        <div>
            <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
        </div>
    )
}

class SuspiciousTransactionsGraph extends React.Component {
    constructor(props) {
        super(props);
        this.state = {


            data: [],
            columns: [
                { "HeaderText": "VRN", "MappingColomn": "vrn" },
                { "HeaderText": "Total Suspicious Activity", "MappingColomn": "totalSuspiciousActivity" },
                { "HeaderText": "Last 3 Month Average", "MappingColomn": "last_3_months_average" }
            ],
            PageSize: 5,
            timeFrameDropDownOptions: [
                { value: 0, label: monthNames[current.getMonth()]},
                { value: 1, label: monthNames[current.getMonth()-1] },
                { value: 2 , label: monthNames[current.getMonth()-2] },
                { value: 3, label: monthNames[current.getMonth()-3] }
            ],
            ViewDropDownOptions: [
                { value: 'No', label: 'ST(No)' },
                { value: 'PKR', label: 'ST(PKR)' }
            ],
            ViewDropDownOptionsNEW: [
                { value: 'No', label: 'ST(No)' },
                { value: 'PKR', label: 'ST(PKR)' }
            ],
            suspiciousdata: {},
            Option: 1,
            Group: 0,
            Vehicle: 0,
            TimeFrameId: 1,
            ViewId: 1,

            BulletInOption: '',
            BulletInGroup: '',
            BulletInsearchCriteria: 'vrn',
            BulletInVRNGroupMultiID: '',
            BulletTimeFrame: 'three_month',




            srcURL_Total_Suspicious_Transactions_bar: '',
            srcURL_Low_Vehicle_Shell_Card_Mileage_Transactions_Transactions_bar: '',
            srcURL_Overcapacity_Transactions_bar: '',
            srcURL_Location_Mismatch_Transactions_bar: '',
            srcURL_Deviated_Routes_Transactions_bar: '',
            srcURL_Excessive_Daily_Fueling_bar: '',
            srcURL_Volume_Mismatch_Transactions_bar: '',


            srcURL_Total_Suspicious_Transactions_Pie: '',
            srcURL_Low_Vehicle_Shell_Card_Mileage_Transactions_Transactions_Pie: '',
            srcURL_Overcapacity_Transactions_Pie: '',
            srcURL_Location_Mismatch_Transactions_Pie: '',
            srcURL_Deviated_Routes_Transactions_Pie: '',
            srcURL_Excessive_Daily_Fueling_Pie: '',
            srcURL_Volume_Mismatch_Transactions_Pie: '',

            srcURL_SuspiciousBulletin: '',



            searchCriteria2: 'vrn',
            Option2: 'vrn',
            Group2: '0',
            Group2Id: '',
            Vehicle2: '',
            Vehicle2Id: '',
            TimeFrameId2: 'three_month',


            searchCriteria1: 'vrn',
            Option1: 'vrn',
            Group1: '0',
            Group1Id: '',
            Vehicle1: '',
            Vehicle1Id: '',
            TimeFrameId1: 0,
            SelectChartView: 'No',
            SelectChartView1: 'No',
            SelectChartView2: 'No',
            SelectChartView3: 'No',
            //reportBaseURL: 'http://localhost:40383/Charts?',
            reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Charts?',
            reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
            reportViewType: '/SSSAS_TabularReports/',
            VRNMappingMasterId: '',
        };
        this.getSuspiciousData = this.getSuspiciousData.bind(this);
        this.getSuspiciousTable1Data = this.getSuspiciousTable1Data.bind(this);
        this.optionChange = this.optionChange.bind(this)
        this.groupChange = this.groupChange.bind(this)
        this.vehicleChange = this.vehicleChange.bind(this)
        this.changeOptionTime = this.changeOptionTime.bind(this)
        this.changeOptionView = this.changeOptionView.bind(this)


        this.changeOptionTime1 = this.changeOptionTime1.bind(this)
        this.changeOptionTime2 = this.changeOptionTime2.bind(this)

        this.optionChange2 = this.optionChange2.bind(this)
        this.groupChange2 = this.groupChange2.bind(this)
        this.vehicleChange2 = this.vehicleChange2.bind(this)

        this.optionChange1 = this.optionChange1.bind(this)
        this.groupChange1 = this.groupChange1.bind(this)
        this.vehicleChange1 = this.vehicleChange1.bind(this)
        this.ViewOption1 = this.ViewOption1.bind(this)
        this.ViewOption2 = this.ViewOption2.bind(this)
        this.ViewOption3 = this.ViewOption3.bind(this)

        this.BulletInOptionChange = this.BulletInOptionChange.bind(this)
        this.BulletInVehicleChange = this.BulletInVehicleChange.bind(this)
        this.BulletInGroupChange = this.BulletInGroupChange.bind(this)
    }

    getSuspiciousData() {
        axiosConfig.post('Portal/GetDashBoardSuspiciousTransAnalytics', {
            "UserAccountBranchID": localStorage.getItem('selectedBranch'),
            "SearchTypeId": 1,
            "CardMappingMasterId": 0,
            "VRNGroupMasterId": 0,
            "StartTime": this.state.fromDate,
            "EndTime": this.state.toDate,
        })
            .then((res) => {
                this.setState({ suspiciousdata: res.data.suspiciousTranAnalytics[0] })
            })
            .catch(console.error)
            .finally(() => {

            });
    }

    componentDidMount() {

        this.getTabularData();
        this.getSuspiciousData();
        //this.getSuspiciousTable1Data();
        this.GenerateGeneric_BarGraph();
        this.GenerateGeneric_PieGraph();

    }


    async changeOptionView(selectedOption) {
        await this.setState({ SelectChartView: selectedOption.value })
        this.getTabularData()
    }

    async changeOptionTime(selectedOption) {
        await this.setState({ TimeFrameId: selectedOption.value })
    }

    async optionChange(selectedOption) {

        if (selectedOption == 1) {

            await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
            this.getSuspiciousTable1Data()
        }
        else
            await this.setState({ Option: selectedOption, Group: 0, Vehicle: 0 })
    }

    async vehicleChange(selectedVehicle) {


        await this.setState({ Vehicle: selectedVehicle, Group: 0 })
        this.getSuspiciousTable1Data()
    }

    async groupChange(selectedGroup) {

        await this.setState({ Group: selectedGroup, Vehicle: 0 })
        this.getSuspiciousTable1Data()
    }


    getSuspiciousTable1Data() {

        axiosConfig.post('Portal/GetHighestSuspiciousActivityEvent', {
            "TimeFrame": this.state.TimeFrameId,
            "SearchTypeId": this.state.Option,
            "CardMappingMasterId": this.state.Vehicle,
            "VRNGroupMasterId": this.state.Group,
            "UserAccountBranchId": localStorage.getItem('selectedBranch'),
            "SuspicousViewId": this.state.ViewId,
        })
            .then((res) => {
                this.setState({ data: res.data.suspiciousActivity })
            })
            .catch(console.error)
            .finally(() => {

            });
    }


    async GenerateGeneric_BarGraph() {

        let ReportName = "BarChart_SuspeciousTrans"

        /*Location Mismatch*/
        let DateRange = this.state.TimeFrameId2;
        this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = ReportName;
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=Location Mismatch&SelectedCriteria=' + this.state.searchCriteria2 + '&SelectChartView=' + this.state.SelectChartView2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')

        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=Location Mismatch&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectededSupect=Location Mismatch&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        this.setState({ srcURL_Location_Mismatch_Transactions_bar: ReportFullURL, showReport: true })


        /*Low Vehicle Shel Card Milleage*/
        reportName = ReportName;
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=LVSCM&SelectedCriteria=' + this.state.searchCriteria2 + '&SelectChartView=' + this.state.SelectChartView2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=LVSCM&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectededSupect=LVSCM&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Low_Vehicle_Shell_Card_Mileage_Transactions_Transactions_bar: ReportFullURL, showReport: true })


        /*Volume Mismatch*/
        reportName = ReportName;
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=Volume Mismatch&SelectedCriteria=' + this.state.searchCriteria2 + '&SelectChartView=' + this.state.SelectChartView2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=Volume Mismatch&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectededSupect=Volume Mismatch&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Volume_Mismatch_Transactions_bar: ReportFullURL, showReport: true })


        /*Deviation*/
        reportName = ReportName;
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=Deviation&SelectedCriteria=' + this.state.searchCriteria2 + '&SelectChartView=' + this.state.SelectChartView2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=Deviation&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectededSupect=Deviation&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Deviated_Routes_Transactions_bar: ReportFullURL, showReport: true })


        /*Excessive Fueling*/
        reportName = ReportName;
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=Excessive Fueling&SelectedCriteria=' + this.state.searchCriteria2 + '&SelectChartView=' + this.state.SelectChartView2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup" && this.state.VRNGroupMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=Excessive Fueling&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        else if (this.state.searchCriteria1 == "vrn" && this.state.VRNMappingMasterId != "") {
            URL_PARAMETERS = 'reportName=' + reportName + '&MappingMasterID=' + this.state.VRNMappingMasterId + '&SelectededSupect=Excessive Fueling&SelectedCriteria=' + this.state.searchCriteria2 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_Excessive_Daily_Fueling_bar: ReportFullURL, showReport: true })

    }

    async GenerateGeneric_PieGraph() {

        let ReportName = "PieChart_ShellSuspeciousCardTransaction"

        // await this.setState({ searchCriteria1:"vrngroup",VRNGroupMasterId:selectedGroup})
        let MonthNo = this.state.TimeFrameId1;
        this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = ReportName;
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=Location Mismatch&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')

        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=Location Mismatch&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }


        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        this.setState({ srcURL_Location_Mismatch_Transactions_Pie: ReportFullURL, showReport: true })

        reportName = ReportName;
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=LVSCM&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=LVSCM&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        await this.setState({ srcURL_Low_Vehicle_Shell_Card_Mileage_Transactions_Transactions_Pie: ReportFullURL, showReport: true })

        reportName = ReportName;
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=Volume Mismatch&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=Volume Mismatch&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        await this.setState({ srcURL_Volume_Mismatch_Transactions_Pie: ReportFullURL, showReport: true })

        reportName = ReportName;
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=Deviation&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=Deviation&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        await this.setState({ srcURL_Deviated_Routes_Transactions_Pie: ReportFullURL, showReport: true })

        reportName = ReportName;
        URL_PARAMETERS = 'reportName=' + reportName + '&SelectededSupect=Excessive Fueling&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.searchCriteria1 == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&VRNGroupingID=' + this.state.VRNGroupMasterId + '&SelectededSupect=Excessive Fueling&SelectChartView=' + this.state.SelectChartView1 + '&MonthNo=' + MonthNo + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }
        reportViewType = this.state.reportViewType
        ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        await this.setState({ srcURL_Excessive_Daily_Fueling_Pie: ReportFullURL, showReport: true })

    }

    /*Start:For Pie Chart*/
    async changeOptionTime1(selectedOption) {

        await this.setState({ TimeFrameId1: selectedOption.value })

        this.GenerateGeneric_PieGraph();
    }

    async optionChange1(selectedOption) {

        if (selectedOption == 1) {
            await this.setState({ searchCriteria1: "vrn" })
            this.GenerateGeneric_PieGraph();

        }
        else
            await this.setState({ Option1: selectedOption, Group1: 0, Vehicle1: 0 })
    }

    async vehicleChange1(selectedVehicle) {


        await this.setState({ Vehicle1: selectedVehicle, Group1: 0 })

    }

    async groupChange1(selectedGroup) {

        await this.setState({ searchCriteria1: "vrngroup", VRNGroupMasterId: selectedGroup })
        this.GenerateGeneric_PieGraph();

    }

    async ViewOption1(selectedView) {
        if (selectedView.value === "No")
            await this.setState({ SelectChartView1: "No" })
        else
            await this.setState({ SelectChartView1: "PKR" })

        this.GenerateGeneric_PieGraph()
    }

    async ViewOption2(selectedView) {
        if (selectedView.value === "No")
            await this.setState({ SelectChartView2: "No" })
        else
            await this.setState({ SelectChartView2: "PKR" })

        this.GenerateGeneric_BarGraph()
    }

    async ViewOption3(selectedView) {

        console.log('ViewOption3');

        if (selectedView.value === "No")
            await this.setState({ SelectChartView3: "No" })
        else
            await this.setState({ SelectChartView3: "PKR" })

        this.getTabularData()
    }

    /*End: For Pie Chart*/

    /*Start:For Bar Chart*/
    async changeOptionTime2(selectedOption) {

        await this.setState({ TimeFrameId2: selectedOption.value })
    }

    async optionChange2(selectedOption) {
        if (selectedOption == 1) {

            await this.setState({ Option2: selectedOption, Group2: 0, Vehicle2: 0 })
            await this.setState({ searchCriteria2: "vrn" })
            this.GenerateGeneric_BarGraph();

        }
        else
            await this.setState({ Option2: selectedOption, Group2: 0, Vehicle2: 0 })
    }

    async vehicleChange2(selectedVehicle) {
        await this.setState({ searchCriteria1: "vrn", VRNMappingMasterId: selectedVehicle })
        this.GenerateGeneric_BarGraph();
    }

    async groupChange2(selectedGroup) {


        await this.setState({ searchCriteria1: "vrngroup", VRNGroupMasterId: selectedGroup })
        this.GenerateGeneric_BarGraph();
        // this.getHighestHSSEEventTable1Data()
    }


    /* Start of Tabular Data */

    async BulletInOptionChange(selectedOption) {
        if (selectedOption == 1) {
            await this.setState({ BulletInsearchCriteria: "vrn" })
            this.getTabularData();
        }
        else
            await this.setState({ BulletInOption: selectedOption, BulletInGroup: 0 })
    }

    async BulletInVehicleChange(selectedVehicle) {


        // await this.setState({ Vehicle: selectedVehicle, Group: 0 })

    }

    async BulletInGroupChange(selectedGroup) {

        await this.setState({ BulletInsearchCriteria: "vrngroup", BulletInVRNGroupMultiID: selectedGroup })
        this.getTabularData();

    }

    /* End of Tabular Data */

    async getTabularData() {
        let DateRange = this.state.BulletTimeFrame;
        // this.setState({ showReport: false })
        let UserBranchID = localStorage.getItem('selectedBranch')
        let reportName = "SuspeciousTransMinAvgMaxTrend";
        let URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=' + this.state.SelectChartView3 + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        if (this.state.BulletInsearchCriteria == "vrngroup") {
            URL_PARAMETERS = 'reportName=' + reportName + '&SelectChartView=' + this.state.SelectChartView3 + '&VRNGroupingID=' + this.state.BulletInVRNGroupMultiID + '&DateRange=' + DateRange + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')
        }

        let reportViewType = this.state.reportViewType
        let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
        console.log('URL Generated: ', ReportFullURL)
        await this.setState({ srcURL_SuspiciousBulletin: ReportFullURL })
    }

    render() {

        return (

            <div>
                <CustomHeader />

                <Container>
                    {/* 
                    <Card>
                        <Card.Body> */}
                    <Row>
                        <Card style={{ width: '100%', height: '50px' }}>
                            <Card.Body>
                                <a href="./MyReports" style={{ color: 'blue' }}>
                                    <p>For more details on your fleet’s performance, click here to visit My Reports</p>
                                </a>
                            </Card.Body>
                        </Card>

                    </Row>

                    <Row>
                        <Col>
                            <CardDeck>
                                <HomeLarge Title="Suspicious Transactions" Icon="fa fa-credit-card font-medium-5" />
                                <HomeMini status={this.state.suspiciousdata.suspiciousDifference} quantityPrice={this.state.suspiciousdata.totalSuspiciousTransactions} Icon="fa fa-exclamation-triangle text-info font-medium-5" percentage="-1" description="Total Suspicious Transactions" cssName="avatar bg-rgba-info p-50 m-0 mb-1" />
                                <HomeMini status={this.state.suspiciousdata.lowVehicleMileageDifference} quantityPrice={this.state.suspiciousdata.lowVehicleMileage} Icon="fa fa-map text-warning font-medium-5" percentage="-1" description="Low Vehicle Shell Card Mileage Transactions" cssName="avatar bg-rgba-warning p-50 m-0 mb-1" />
                                <HomeMini status={this.state.suspiciousdata.excessiveDailyFuelingDifference} quantityPrice={this.state.suspiciousdata.excessiveDailyFuelingTransactions} Icon="fa fa-database text-danger font-medium-5" percentage="-1" description="Excessive Daily Fueling Transactions" cssName="avatar bg-rgba-danger p-50 m-0 mb-1" />
                                <HomeMini status={this.state.suspiciousdata.locationMismatchTransactionsDifference} quantityPrice={this.state.suspiciousdata.locationMismatchTransactions} Icon="fa fa-map text-primary font-medium-5" percentage="-1" description="Location Mismatch Transactions" cssName="avatar bg-rgba-primary p-50 m-0 mb-1" />
                                <HomeMini status={this.state.suspiciousdata.deviatedRouteTransactionsDifference} quantityPrice={this.state.suspiciousdata.deviatedRouteTransactions} Icon="fa fa-tint text-success font-medium-5" percentage="-1" description="Off-Route Transactions" cssName="avatar bg-rgba-success p-50 m-0 mb-1" />
                            </CardDeck>
                        </Col>
                    </Row>

                    <Row>

                        <Col className="col-md-12">

                            <Card>
                                <Card.Title>
                                    <h3 class="text-left p-4">Suspicious Transactions Bulletin</h3>
                                </Card.Title>


                                <Card.Body>
                                    <div className="form-group">
                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose View</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.ViewDropDownOptionsNEW}
                                                    styles={customStyles}
                                                    onChange={this.ViewOption3}
                                                    defaultValue={{ label: "ST(No)", value: "No" }}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="col-md-4">
                                                <h5>Choose Base</h5>
                                            </div>
                                            <div className="col-md-3">
                                                <GroupVRNSelect
                                                    isMultiInGroup='true'
                                                    onOptionChange={this.BulletInOptionChange}
                                                    onGroupChange={this.BulletInGroupChange}
                                                    onVehicleChange={this.BulletInVehicleChange} />
                                                {/* <GroupVRNSelect
                                                    showFilterText='true'
                                                    showVehiclesInDropDown='yes'
                                                    isMultiInGroup='false'
                                                    isMultiInVehicle='false'
                                                    onOptionChange={this.optionChange}
                                                    onGroupChange={this.groupChange}
                                                    onVehicleChange={this.vehicleChange}
                                            ></GroupVRNSelect> */}

                                            </div>
                                        </Row>

                                    </div>

                                    <Row>
                                        <div className="col-xl-12 col-lg-12 col-md-12 p-0 pr-2">
                                            <Card>
                                                <Card.Body className="p-0">
                                                    <Iframe src={this.state.srcURL_SuspiciousBulletin} height="430" width="1250" />

                                                </Card.Body>
                                            </Card>
                                        </div>
                                    </Row>

                                </Card.Body>
                            </Card>


                        </Col>

                    </Row>

                    <Row>

                        <Col className="col-md-12">

                            <Card>
                                <Card.Title>
                                    <h3 class="text-left p-4">Suspicious Transactions Summary</h3>
                                </Card.Title>


                                <Card.Body>
                                    <div className="form-group">
                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose Time Frame</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.timeFrameDropDownOptions}
                                                    styles={customStyles}
                                                    onChange={this.changeOptionTime1}
                                                    defaultValue={{ label: monthNames[current.getMonth()], value: 0 }}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose View</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.ViewDropDownOptionsNEW}
                                                    styles={customStyles}
                                                    onChange={this.ViewOption1}
                                                    defaultValue={{ label: "ST(No)", value: "No" }}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="col-md-4">
                                                <h5>Choose Base</h5>
                                            </div>
                                            <div className="col-md-3">
                                                <GroupVRNSelect
                                                    isMultiInGroup='true'
                                                    onOptionChange={this.optionChange1}
                                                    onGroupChange={this.groupChange1}
                                                    onVehicleChange={this.vehicleChange1}
                                                />


                                            </div>
                                        </Row>

                                    </div>

                                    <Row>
                                        <div className="col-md-12 p-0 pr-2">
                                            <Card>


                                                <Card.Body className="p-0">
                                                    <div className="tab-pane active" id="pieTab" role="tabpanel" aria-labelledby="home-tab-justified">

                                                        <Row>

                                                            <div className="col-sm-6 col-12">

                                                                <Card style={{ border: '1px solid #ccc' }}>

                                                                    <Card.Body className="p-0">

                                                                        <Iframe src={this.state.srcURL_Location_Mismatch_Transactions_Pie} height="430" width="100%" />
                                                                    </Card.Body>


                                                                </Card>
                                                            </div>

                                                            <div className="col-sm-6 col-12">

                                                                <Card style={{ border: '1px solid #ccc' }}>

                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Deviated_Routes_Transactions_Pie} height="430" width="100%" />
                                                                    </Card.Body>


                                                                </Card>
                                                            </div>



                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Excessive_Daily_Fueling_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Volume_Mismatch_Transactions_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>
                                                            <div className="col-sm-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Low_Vehicle_Shell_Card_Mileage_Transactions_Transactions_Pie} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>




                                                        </Row>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </div>

                                    </Row>

                                </Card.Body>
                            </Card>


                        </Col>

                    </Row>


{/* 
                    <Row>

                        <Col className="col-md-12">

                            <Card>
                                <Card.Title>
                                    <h3 class="text-left p-4">Suspicious Transactions Analysis</h3>
                                </Card.Title>


                                <Card.Body>
                                    <div className="form-group">
                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose Time Frame</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.timeFrameDropDownOptionsNew}
                                                    styles={customStyles}
                                                    onChange={this.changeOptionTime2}
                                                    defaultValue={{ label: "Last 3 months", value: "three_month" }}
                                                    isDisabled={true}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="form-group col-lg-4 col-md-12">
                                                <h5>Choose View</h5>
                                            </div>
                                            <div className="form-group col-lg-3 col-md-12">
                                                <Select
                                                    options={this.state.ViewDropDownOptionsNEW}
                                                    styles={customStyles}
                                                    onChange={this.ViewOption2}
                                                    defaultValue={{ label: "ST(No)", value: "No" }}
                                                >
                                                </Select>
                                            </div>
                                        </Row>

                                        <Row>

                                            <div className="col-md-4">
                                                <h5>Choose Base</h5>
                                            </div>
                                            <div className="col-md-3">
                                                <GroupVRNSelect
                                                    isMultiInGroup='true'
                                                    isMultiInVehicle='true'
                                                    showVehiclesInDropDown='yes'
                                                    onOptionChange={this.optionChange2}
                                                    onGroupChange={this.groupChange2}
                                                    onVehicleChange={this.vehicleChange2}

                                                />
                                            </div>
                                        </Row>

                                    </div>

                                    <Row>
                                        <div className="col-md-12 p-0 pr-2">
                                            <Card>

                                                <Card.Body className="p-0">
                                                    <div className="tab-pane active" id="pieTab" role="tabpanel" aria-labelledby="home-tab-justified">
                                                        <Row>


                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Low_Vehicle_Shell_Card_Mileage_Transactions_Transactions_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>



                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Location_Mismatch_Transactions_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Deviated_Routes_Transactions_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Excessive_Daily_Fueling_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>

                                                            <div className="col-md-6 col-12">
                                                                <Card style={{ border: '1px solid #ccc' }}>
                                                                    <Card.Body className="p-0">
                                                                        <Iframe src={this.state.srcURL_Volume_Mismatch_Transactions_bar} height="430" width="100%" />
                                                                    </Card.Body>
                                                                </Card>
                                                            </div>


                                                        </Row>


                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </div>

                                    </Row>

                                </Card.Body>
                            </Card>


                        </Col>

                    </Row>
 */}

                </Container>
            </div >
        );
    }
}

export default SuspiciousTransactionsGraph;